export class CategoryMapper {
	static formatCategoryList(list) {
		const mapped = list.map((item) => ({
			id: item.id ?? item.Id,
			shopId: item.id ?? item.Id,
			businessId: item.businessId ?? item.BusinessId ?? item.id ?? item.Id,
			title: item.name ?? item.Name,
			image: item.coverImagePath ?? item.CoverImagePath,
			score: item.point ?? item.Point,
			reviewCount:
				item.reviewCount ??
				item.reviewsCount ??
				item.commentCount ??
				item.commentsCount ??
				item.pointCount ??
				item.pointsCount ??
				item.ReviewCount ??
				item.ReviewsCount ??
				item.CommentCount ??
				item.CommentsCount ??
				item.PointCount ??
				item.PointsCount,
			address: item.address ?? item.Address,
			description: item.description ?? item.Description,
			isOpen: (item.isClose ?? item.IsClose) === false,
			openShop: item.isClose ?? item.IsClose,
			citySlug: item.citySlug ?? item.CitySlug ?? item.city?.key ?? item.City?.Key ?? item.city?.slug ?? item.City?.Slug,
			businessSlug: item.businessSlug ?? item.BusinessSlug ?? item.slug ?? item.Slug,
			slug: item.slug ?? item.Slug,
			city: item.city ?? item.City,
		}));
		return mapped;
	}
}
